import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import TopNavigation from "@cloudscape-design/components/top-navigation";
import {
  AppLayout,
  BreadcrumbGroup,
  Container,
  ContentLayout,
  Flashbar,
  Header,
  HelpPanel,
  Link,
  SideNavigation,
  SplitPanel,
} from "@cloudscape-design/components";
import { AuthApi, ApiClient } from "./tradingApiSdk/src";
import HelloComponent from "./HelloComponent";

export default function HomePage({ onLogout }) {
  const navigate = useNavigate();

  useEffect(() => {
    async function checkStatus() {
      try {
        const client = new ApiClient();
        client.enableCookies = true;
        client.fetchOptions = { credentials: "include", cache: "no-cache" };

        const res = await fetch(`${client.basePath}/auth/status`, {
          credentials: "include",
          cache: "no-cache",
        });
        const data = await res.json();

        if (!data.logged_in) {
          onLogout();
          navigate("/login", { replace: true }); // ✅ Instantly redirect
        }
      } catch (err) {
        console.error("Error verifying session:", err);
      }
    }
    checkStatus();
  }, [navigate, onLogout]);

  const handleUtilityClick = async (itemId) => {
    if (itemId === "logout") {
      try {
        const client = new ApiClient();
        client.enableCookies = true;
        client.fetchOptions = { credentials: "include" };

        const authApi = new AuthApi(client);
        await authApi.getLogoutResource();

        // ✅ Fully clear session cookies
        document.cookie = "session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        document.cookie = "session=; Max-Age=0; path=/; domain=" + window.location.hostname;

        onLogout();
        navigate("/login", { replace: true }); // ✅ Force immediate redirect

      } catch (err) {
        console.error("Logout error", err);
      }
    }
  };

  const topNavUtilities = [
    {
      type: "menu-dropdown",
      text: "Customer Name",
      description: "email@example.com",
      iconName: "user-profile",
      items: [
        { id: "profile", text: "Profile" },
        { id: "preferences", text: "Preferences" },
        { id: "logout", text: "Sign out" },
      ],
      onItemClick: (e) => {
        handleUtilityClick(e.detail.id);
      },
    },
  ];

  return (
    <>
      <TopNavigation identity={{ href: "#", title: "Service" }} utilities={topNavUtilities} />
      <AppLayout
        breadcrumbs={
          <BreadcrumbGroup 
            items={[{ text: "Home", href: "#" }, { text: "Service", href: "#" }]} 
          />
        }
        navigationOpen={true}
        onNavigationChange={() => {}}
        toolsOpen={false}
        onToolsChange={() => {}}
        navigation={
          <SideNavigation
            header={{ href: "#", text: "Service name" }}
            items={[{ type: "link", text: "Page #1", href: "#" }]}
          />
        }
        notifications={
          <Flashbar 
            items={[{ 
              type: "info", 
              dismissible: true, 
              content: "Welcome!", 
              id: "message_1",
              onDismiss: () => {}
            }]} 
          />
        }
        tools={
          <HelpPanel header={<h2>Overview</h2>}>This is a help panel from Cloudscape.</HelpPanel>
        }
        content={
          <ContentLayout
            header={
              <Header variant="h1" info={<Link variant="info">Info</Link>}>
                A1Ultra Home
              </Header>
            }
          >
            <Container header={<Header variant="h2" description="Container description">Container header</Header>}>
              <HelloComponent />
            </Container>
          </ContentLayout>
        }
        splitPanel={<SplitPanel header="Split panel header">Split panel content</SplitPanel>}
      />
    </>
  );
}